import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0 12px;
  width: 100%;
  max-width: 662px;
  margin: 0 auto;
  align-items: center;
`;
const SubscriptionGroup = styled.div`
  width: 100%;
  max-width: 662px;
  margin: 0 auto;
  margin-bottom: 24px;
  ${mobile_xl(css`
    margin-bottom: 80px;
  `)}
`;
const PersonalText = styled.div`
  ${Typography.heading_lg}
  color: var(--text-primary);
`;
const Content = styled.div`
  border-radius: var(--border-radius-6);
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  ${mobile_xl(css`
    margin-top: 8px;
  `)}
`;

const First = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 12px 16px;
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
  }
`;
const Details = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Icons = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  .active {
    border-radius: var(--border-radius-4);
    background: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    gap: 8px;
  `)}
`;
const Heading = styled.div`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
`;

const Description = styled.div`
  ${Typography.body_md}
  color: var(--text-secondary);
`;

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: var(--border-radius-4);
  :hover {
    background: var(--neutral-secondary);
  }
  ${mobile_xl(css`
    padding: 6px;
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

const EmptyStateApi = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ApiLink = styled.div`
  color: var(--text-primary);
  padding-top: 13px;
  ${Typography.body_md}
  a {
    ${Typography.body_md}
    color: var(--brand-primary);
    cursor: pointer;
    padding-left: 5px;
    text-decoration: none;
  }
  &.empty-state {
    text-align: center;
    padding-top: 12px;
  }
`;
export {
  Header,
  SubscriptionGroup,
  PersonalText,
  Content,
  First,
  Details,
  Icons,
  Heading,
  Description,
  Icon,
  EmptyStateApi,
  ApiLink
};
